module.exports = __webpack_public_path__ + "img/inboxaware-nav-header-logo.97ac5345.svg";